module.exports = __webpack_public_path__ + "img/11_hardening_(white).172758bd.svg";